import type { InformationBlock } from '../../domain/blocs/InformationBloc'
import { BlocType } from '../../domain/BlocType'

export const mapInformationBlockFromApi = (infoBloc: any): InformationBlock | undefined => {
  if (!infoBloc) return undefined
  return {
    blocType: BlocType.INFORMATION_BLOCK,
    title: infoBloc.fields.title || '',
    content: infoBloc.fields.content,
  }
}
